import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from "@air/primitive-input";
import { useField } from "formik";
import { forwardRef } from "react";
export const FormikInput = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { name, ...restOfProps } = param;
    const [field] = useField(name);
    return /*#__PURE__*/ _jsx(Input, {
        ...field,
        ...restOfProps,
        ref: forwardedRef
    });
});
FormikInput.displayName = "FormikInput";
